(function(){
  if (window.__bfcmEb) return; window.__bfcmEb = true;
  const formatterCache = new Map();
  function parseTarget(value, timeZone) {
    const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!match) return NaN;

    const [, y, mo, d, h, mi, sec = '0'] = match;
    const year = Number(y);
    const month = Number(mo);
    const day = Number(d);
    const hour = Number(h);
    const minute = Number(mi);
    const second = Number(sec);
    const localTimestamp = Date.UTC(year, month - 1, day, hour, minute, second);
    const check = new Date(localTimestamp);

    if (
      check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 ||
      check.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59
    ) return NaN;
    if (!timeZone) return NaN;

    try {
      if (!formatterCache.has(timeZone)) {
        formatterCache.set(timeZone, new Intl.DateTimeFormat('en-CA', {
          timeZone,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        }));
      }

      const formatter = formatterCache.get(timeZone);
      let timestamp = localTimestamp;
      for (let pass = 0; pass < 4; pass += 1) {
        const parts = Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map(part => [part.type, part.value]));
        const represented = Date.UTC(
          Number(parts.year), Number(parts.month) - 1, Number(parts.day),
          Number(parts.hour), Number(parts.minute), Number(parts.second)
        );
        const difference = localTimestamp - represented;
        if (!difference) return timestamp;
        timestamp += difference;
      }
    } catch {
      return NaN;
    }

    return NaN;
  }

  var pad = function(n){ return String(n).padStart(2,'0'); };
  function tick(){
    document.querySelectorAll('[data-eb-cd]').forEach(function(el){
      var t = parseTarget(el.getAttribute('data-eb-cd'), el.getAttribute('data-eb-timezone')); if (isNaN(t)) return;
      var x = Math.max(0, t - Date.now())/1000, d = Math.floor(x/86400), h = Math.floor(x%86400/3600), m = Math.floor(x%3600/60), s = Math.floor(x%60);
      var set = function(k,v){ el.querySelectorAll('[data-u="'+k+'"]').forEach(function(n){ n.textContent = v; }); };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s)); set('short', d+'d '+pad(h)+'h '+pad(m)+'m');
    });
  }
  function gallery(root){
    (root||document).querySelectorAll('[data-eb-gal]').forEach(function(g){
      if (g.__eb) return; g.__eb = 1;
      var sc = g.querySelector('.eb-scroll'), dots = [].slice.call(g.querySelectorAll('.eb-gal__dots i'));
      var idx = function(){ return Math.round(sc.scrollLeft / sc.clientWidth); };
      var upd = function(){ var i = idx(); dots.forEach(function(d,j){ d.classList.toggle('on', i===j); }); };
      sc.addEventListener('scroll', function(){ requestAnimationFrame(upd); });
      var go = function(i){ sc.scrollTo({left: i*sc.clientWidth, behavior:'smooth'}); };
      dots.forEach(function(d,j){ d.addEventListener('click', function(){ go(j); }); });
      var p = g.querySelector('.eb-gal__nav--p'), n = g.querySelector('.eb-gal__nav--n'), L = dots.length || 1;
      if (p) p.addEventListener('click', function(){ go((idx()-1+L)%L); });
      if (n) n.addEventListener('click', function(){ go((idx()+1)%L); });
      upd();
    });
  }
  function spend(root){
    (root||document).querySelectorAll('[data-eb-spend]').forEach(function(sp){
      if (sp.__eb) return; sp.__eb = 1;
      var rail = sp.querySelector('.eb-rail'), cards = [].slice.call(sp.querySelectorAll('.eb-rc')), bar = sp.querySelector('.eb-prog i'), empty = sp.querySelector('.eb-empty');
      var cats = [].slice.call(sp.querySelectorAll('[data-cat]')), prices = [].slice.call(sp.querySelectorAll('[data-max]'));
      var state = { cat: cats[0] ? cats[0].dataset.cat : '', max: Infinity };
      var prog = function(){ var w = rail.scrollWidth - rail.clientWidth, vis = rail.clientWidth / rail.scrollWidth; bar.style.width = Math.max(12, vis*100)+'%'; bar.style.left = (w>0 ? rail.scrollLeft/w : 0)*(100-Math.max(12,vis*100))+'%'; };
      var apply = function(){ var n = 0;
        cards.forEach(function(c){ var ok = (!state.cat || c.dataset.cats.split(' ').indexOf(state.cat) > -1) && parseFloat(c.dataset.sale) < state.max; c.hidden = !ok; if (ok) n++; });
        cats.forEach(function(b){ b.classList.toggle('on', b.dataset.cat===state.cat); });
        prices.forEach(function(b){ b.classList.toggle('on', parseFloat(b.dataset.max||'Infinity')===state.max || (b.dataset.max==='' && state.max===Infinity)); });
        if (empty) empty.classList.toggle('on', n===0); rail.scrollLeft = 0; prog();
      };
      cats.forEach(function(b){ var c = cards.filter(function(x){ return x.dataset.cats.split(' ').indexOf(b.dataset.cat) > -1; }).length; var s = b.querySelector('small'); if (s) s.textContent = c + (c===1?' product':' products'); b.addEventListener('click', function(){ state.cat = b.dataset.cat; apply(); }); });
      prices.forEach(function(b){ b.addEventListener('click', function(){ state.max = b.dataset.max ? parseFloat(b.dataset.max) : Infinity; apply(); }); });
      rail.addEventListener('scroll', function(){ requestAnimationFrame(prog); }); window.addEventListener('resize', prog);
      var a = sp.querySelectorAll('.eb-arrows button'); if (a[0]) a[0].addEventListener('click', function(){ rail.scrollBy({left:-rail.clientWidth*.8, behavior:'smooth'}); }); if (a[1]) a[1].addEventListener('click', function(){ rail.scrollBy({left:rail.clientWidth*.8, behavior:'smooth'}); });
      apply();
    });
  }
  function mbar(){
    var b = document.querySelector('[data-eb-mbar]'), h = document.querySelector('.eb-hero'); if (!b || !h) return;
    document.body.classList.add('eb-has-bar');
    new IntersectionObserver(function(es){ es.forEach(function(e){ b.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(h);
  }
  document.addEventListener('click', function(e){
    var add = e.target.closest('[data-eb-add]'); if (add){ e.preventDefault(); if (add.classList.contains('is-on')) { window.location.href = '/cart'; return; }
      var items = add.dataset.ebAdd.split(',').filter(Boolean).map(function(id){ return { id: +id, quantity: 1 }; });
      var lbl = add.innerHTML; add.style.opacity = .6;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json(); }).then(function(){ add.style.opacity = 1; add.classList.add('is-on'); add.textContent = add.dataset.added || 'Added ✓ · View cart'; document.dispatchEvent(new CustomEvent('cart:refresh')); fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function(n){ n.textContent = c.item_count; }); }).catch(function(){}); })
        .catch(function(){ add.style.opacity = 1; add.innerHTML = lbl; });
    }
    var go = e.target.closest('[data-eb-go]'); if (go && go.dataset.ebGo.startsWith('#')){ var t = document.getElementById(go.dataset.ebGo.slice(1)); if (t){ e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - 60, behavior:'smooth' }); } }
    var pl = e.target.closest('.eb-uv__play'); if (pl){ var v = pl.parentNode.querySelector('video'); if (v){ v.controls = true; v.play(); pl.remove(); } }
  });
  function init(r){ tick(); gallery(r); spend(r); }
  function boot(){ init(); mbar(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
